import React from 'react';

const WriteBlog = () => {
    return (
      <div>
        <h1 className="text-center font-bold md:text-5xl text-2xl md:m-10 m-1 italic">
          Blogs
        </h1>
        {/* ---------new+ blog */}
        <div className="flex justify-end md:mr-10 mr-4">
          <label htmlFor="my-modal-3" className="">
            <div className="btn md:btn-md btn-sm gap-2">
              New
              <div className="badge badge-secondary">+</div>
            </div>
          </label>
        </div>
        {/* -------------------write blog-------------- */}
        <input type="checkbox" id="my-modal-3" className="modal-toggle" />
        <div className="modal">
          <div className="modal-box relative">
            <label
              htmlFor="my-modal-3"
              className="btn btn-sm btn-circle absolute right-2 top-2"
            >
              ✕
            </label>
            <h3 className="text-lg font-bold text-center">Write a Blog!</h3>
            <textarea
              className="textarea textarea-accent w-full h-48 py-4 mt-10 text-lg"
              placeholder="Let's Start...."
            ></textarea>
            <div className="alert p-1 bg-white">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="stroke-info flex-shrink-0 w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <span className="text-xs">
                  Upload a blog cover image. (400x225)
                </span>
              </div>
            </div>
            <input
              type="file"
              className="file-input file-input-bordered file-input-sm w-full max-w-xs md:mr-10 "
            />
            <button className="btn btn-accent btn-sm mt-3">Post</button>
          </div>
        </div>

 {/* ---------------------------------blogs----------------------------------------- */}
        <div className="flex flex-col flex-wrap  max-w-screen-xl lg:flex-row my-10 mx-auto gap-3 ">

          <input type="checkbox" id="my-modal-5" className="modal-toggle" />
          <div className="modal">
            <div className="modal-box w-11/12 max-w-5xl max-h-96 relative">
              <label
                htmlFor="my-modal-5"
                className="btn btn-sm btn-circle absolute right-2 top-2"
              >
                ✕
              </label>
              {/*--------- blog details--------- */}
              <h2 className="card-title text-4xl font-bold">Shoes!</h2>
              <p className="text-justify text-2xl mt-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
                assumenda velit possimus perspiciatis nemo minus voluptatem
                facilis cum excepturi accusantium architecto veniam, enim
                reiciendis rerum fugiat accusamus, quisquam aut! Saepe.
              </p>
              {/* --------------blog details close------- */}
              <div className="modal-action">
                <label htmlFor="my-modal-5" className="btn">
                  Done
                </label>
              </div>
            </div>
          </div>
          {/* ----blog cover---- */}
          <div className="card md:w-96 w-80 mx-auto bg-base-100 shadow-2xl">
            <figure>
              <img src="https://placeimg.com/400/225/arch" alt="Shoes" />
            </figure>
            <div className="card-body pl-4 pt-4">
              <h2 className="card-title">Shoes!</h2>
              <p className="text-justify">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
                assumenda velit possimus perspiciatis nemo minus voluptatem
                facilis cum excepturi accusantium architecto veniam, enim
                reiciendis rerum fugiat accusamus, quisquam aut! Saepe.
              </p>
              <div className="card-actions justify-end mt-4">
                <label htmlFor="my-modal-5">
                  <div className="badge badge-lg cursor-pointer bg-indigo-600 text-white py-4 px-5">
                    Read Now
                  </div>
                </label>
              </div>
            </div>
          </div>

          {/* ----------blog-2 hard coded */}
          <input type="checkbox" id="my-modal-5" className="modal-toggle" />
          <div className="modal">
            <div className="modal-box w-11/12 max-w-5xl max-h-96 relative">
              <label
                htmlFor="my-modal-5"
                className="btn btn-sm btn-circle absolute right-2 top-2"
              >
                ✕
              </label>
              {/*--------- blog details--------- */}
              <h2 className="card-title text-4xl font-bold">Shoes!</h2>
              <p className="text-justify text-2xl mt-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
                assumenda velit possimus perspiciatis nemo minus voluptatem
                facilis cum excepturi accusantium architecto veniam, enim
                reiciendis rerum fugiat accusamus, quisquam aut! Saepe.
              </p>
              {/* --------------blog details close------- */}
              <div className="modal-action">
                <label htmlFor="my-modal-5" className="btn">
                  Done
                </label>
              </div>
            </div>
          </div>
          {/* ----blog cover---- */}
          <div className="card md:w-96 w-80 mx-auto bg-base-100 shadow-2xl">
            <figure>
              <img src="https://placeimg.com/400/225/arch" alt="Shoes" />
            </figure>
            <div className="card-body pl-4 pt-4">
              <h2 className="card-title">Shoes!</h2>
              <p className="text-justify">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
                assumenda velit possimus perspiciatis nemo minus voluptatem
                facilis cum excepturi accusantium architecto veniam, enim
                reiciendis rerum fugiat accusamus, quisquam aut! Saepe.
              </p>
              <div className="card-actions justify-end mt-4">
                <label htmlFor="my-modal-5">
                  <div className="badge badge-lg cursor-pointer bg-indigo-600 text-white py-4 px-5">
                    Read Now
                  </div>
                </label>
              </div>
            </div>
          </div>


          {/* ------blog 3 hard coded--------*/}
          <input type="checkbox" id="my-modal-5" className="modal-toggle" />
          <div className="modal">
            <div className="modal-box w-11/12 max-w-5xl max-h-96 relative">
              <label
                htmlFor="my-modal-5"
                className="btn btn-sm btn-circle absolute right-2 top-2"
              >
                ✕
              </label>
              {/*--------- blog details--------- */}
              <h2 className="card-title text-4xl font-bold">Shoes!</h2>
              <p className="text-justify text-2xl mt-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
                assumenda velit possimus perspiciatis nemo minus voluptatem
                facilis cum excepturi accusantium architecto veniam, enim
                reiciendis rerum fugiat accusamus, quisquam aut! Saepe.
              </p>
              {/* --------------blog details close------- */}
              <div className="modal-action">
                <label htmlFor="my-modal-5" className="btn">
                  Done
                </label>
              </div>
            </div>
          </div>
          {/* ----blog cover---- */}
          <div className="card md:w-96 w-80 mx-auto bg-base-100 shadow-2xl">
            <figure>
              <img src="https://placeimg.com/400/225/arch" alt="Shoes" />
            </figure>
            <div className="card-body pl-4 pt-4">
              <h2 className="card-title">Shoes!</h2>
              <p className="text-justify">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
                assumenda velit possimus perspiciatis nemo minus voluptatem
                facilis cum excepturi accusantium architecto veniam, enim
                reiciendis rerum fugiat accusamus, quisquam aut! Saepe.
              </p>
              <div className="card-actions justify-end mt-4">
                <label htmlFor="my-modal-5">
                  <div className="badge badge-lg cursor-pointer bg-indigo-600 text-white py-4 px-5">
                    Read Now
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default WriteBlog;